import { getInviteInfo } from '@api/company.api';
import { useEffect, useState } from 'react'
import icon_wechat_worker from './img/icon-wechat-worker.png'

import './index.css'
export default function JoinCompany(props: any) {
  const [title, setTitle] = useState('');
  const [qrUrl, setQrUrl] = useState('');
  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    initBasicInfo({ inviteId: query.get('inviteId') || '', inviteType: query.get('inviteType') || '1' });
  })
  
  async function initBasicInfo(params: { inviteId: string, inviteType: string }) {
    const res = await getInviteInfo({ inviteId: params.inviteId, inviteType: params.inviteType })
    setTitle(res.data.name)
    setQrUrl(res.data.qrUrl)
  }
  return (
    <div className="company-invite-body">
      <div className="shadow background-card">
        <div className="top-part">
          <span>{title}</span>
          <div className="ball-left"></div>
          <div className="ball-right"></div>
        </div>
        <div className="bottom-part">
          <img className="qr-code" src={qrUrl} alt=''/>
          <img className="icon" src={icon_wechat_worker} alt=''/>
          <p>长按二维码加入组织</p>
        </div>
      </div>
    </div>
  )
}